export const iconFontAwesomeChartsDiagramsChartGantt = (
	<i className="fa-solid fa-chart-gantt"></i>
);
